/**
 * Human-readable job duration from a minutes value.
 *   0 / null  -> "-"
 *   45        -> "45 min"
 *   120       -> "2 hours"
 *   90        -> "1hr 30min"
 */
export const formatDuration = (minutes) => {
  const total = Number(minutes);
  if (!total || Number.isNaN(total) || total <= 0) return "-";

  const hours = Math.floor(total / 60);
  const mins = total % 60;

  if (hours === 0) return `${mins} min`;
  if (mins === 0) return `${hours} hour${hours > 1 ? "s" : ""}`;
  return `${hours}hr ${mins.toString().padStart(2, "0")}min`;
};

export default formatDuration;
